import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import "./assets/css/Footer.css";

function Footer() {

  const year = new Date().getFullYear();

  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {

    const handleScroll = () => {

      if (window.scrollY > 300) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }

    };

    window.addEventListener("scroll", handleScroll);

    return () =>
      window.removeEventListener("scroll", handleScroll);

  }, []);

  const scrollToTop = () => {

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

  };

  return (
    <>

      {/* Scroll To Top Button */}

      <button
        className={`scroll-top-btn ${showTopBtn ? "show" : ""}`}
        onClick={scrollToTop}
        aria-label="Scroll To Top"
      >
        <i className="bi bi-arrow-up"></i>
      </button>

      {/* Footer */}

      <footer className="apexo-footer">

        <div className="container">

          <div className="row align-items-center">

            {/* Copyright */}

            <div className="col-lg-6 col-md-12 text-center text-lg-start mb-2 mb-lg-0">

              <p className="footer-text mb-0">
                © {year} ApexoIndustrial.com | All Rights Reserved
              </p>

            </div>

            {/* Links */}

            <div className="col-lg-6 col-md-12 text-center text-lg-end">

              <div className="footer-links">

                <NavLink to="/">
                  Privacy Policy
                </NavLink>

                <span className="divider">|</span>

                <NavLink to="/">
                  Terms & Conditions
                </NavLink>

              </div>

            </div>

          </div>

        </div>

      </footer>

    </>
  );

}

export default Footer;